import { render, staticRenderFns } from "./InsuranceHistoryTable.vue?vue&type=template&id=3d07ab20&"
import script from "./InsuranceHistoryTable.vue?vue&type=script&lang=js&"
export * from "./InsuranceHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceHistoryTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports